export function round(number, precision, mode) {
    mode = mode || 'round'
    const factor = 10 ** precision
    const tempNumber = number * factor
    const roundedTempNumber = Math[mode](tempNumber)
    return roundedTempNumber / factor
}
